export default __webpack_public_path__ + "static/media/next-arrow.022c14b4.svg";